/* eslint-disable no-unused-vars */
import React from 'react'
import querystring from 'querystring'
import { post, get, createFetchTask } from '@integec/fetch-task'

import {
  getCard97,
  deleteCard97,
  postCard97,
  postDukeCard97,
  getDukeCard97,
  deleteDukeCard97,
  getDukeCard97DataCheck,
  getCard97DataCheck,
  getCard97ExtensionData,
  getDukeCard97ExtensionData,
  getDominionCard97,
  postDominionCard97,
  deleteDominionCard97,
  getDominionCard97DataCheck,
  getDominionCard97ExtensionData,
  // getBkfCard97,
  getBKFCard97DataCheck,
  postBrookfieldCard97,
  getBrookfieldCard97ExtensionData,
  getBkfCard97ByPost,
  getCard97PJM,
  postBrookfieldCard97Delete,
  getCard97ByPost,
  getDominionCard97ByPost,
  getDukeCard97ByPost,
  getNRGCard97ExtensionData,
  getNRGCard97DataCheck,
  getNRGCard97ByPost,
  postNRGCard97,
  postNRGCard97Delete,
} from 'api/pgads'

import Card97Extension from './component/card97/Card97Extension'
import DukeNucExtension from './component/card97/DukeNucExtension'
import DominionExtendion from './component/card97/DominionExtension'
import CPSCard97Extension from './component/card97/CPSCard97Extension'
import SrpExtension from './component/card97/SrpExtension'
import BKFCard97Extension from './component/card97/BKFCard97Extension'
import APSCard97Extension from './component/card97/ApsExtension'
import NRGCard97Extension from './component/card97/NRGCard97Extension'
import CoopCard97Extension from './component/card97/CoopCard97Extension'
import {
  DUCK_CLIENT,
  DOM_CLIENT,
  CPS_CLIENT,
  SRP_CLIENT,
  BROOKFIELD_CLIENT,
  APS_CLIENT,
  PJM_CLIENT,
  NRG_CLIENT,
  LANYARD_CLIENT,
  GENON_CLIENT,
  CALPLINE_CLIENT,
  COOP_CLIENT,
} from 'client'
import CalpCard97Extension from './component/card97/CalpCard97Extension'

export const isAvaliableExtensionPanel = (client, spec) => {
  switch (client) {
    case DUCK_CLIENT:
    case DOM_CLIENT:
    case CPS_CLIENT:
    case CALPLINE_CLIENT:
    case SRP_CLIENT:
    case BROOKFIELD_CLIENT:
    case APS_CLIENT:
    case NRG_CLIENT:
    case GENON_CLIENT:
    case LANYARD_CLIENT:
    case COOP_CLIENT:
      return true
    default:
      return spec.avaliable || false
  }
}

export const getExtensionPanel = client => {
  switch (client) {
    case DUCK_CLIENT:
      return DukeNucExtension
    case DOM_CLIENT:
      return DominionExtendion
    case CPS_CLIENT:
      return CPSCard97Extension
    case CALPLINE_CLIENT:
      return CalpCard97Extension
    case SRP_CLIENT:
      return props => <SrpExtension {...props} />
    case BROOKFIELD_CLIENT:
      return props => <BKFCard97Extension {...props} />
    case APS_CLIENT:
      return props => <APSCard97Extension {...props} />
    // case APS_CLIENT:
    //  return APSCard97Extension // bcoz connect is used
    case COOP_CLIENT:
      return props => <CoopCard97Extension {...props} />
    case NRG_CLIENT:
    case GENON_CLIENT:
    case LANYARD_CLIENT:
      return NRGCard97Extension
    default:
      return Card97Extension
  }
}

export const getExtensionDataByClient = client => {
  switch (client) {
    case DUCK_CLIENT:
      return getDukeCard97ExtensionData
    case DOM_CLIENT:
      return getDominionCard97ExtensionData
    case BROOKFIELD_CLIENT:
      return getBrookfieldCard97ExtensionData
    case NRG_CLIENT:
    case GENON_CLIENT:
    case LANYARD_CLIENT:
      return getNRGCard97ExtensionData
    default:
      return getCard97ExtensionData
  }
}

export const getDataCheckServiceByclient = client => {
  switch (client) {
    case DUCK_CLIENT:
      return getDukeCard97DataCheck
    case DOM_CLIENT:
      return getDominionCard97DataCheck
    case BROOKFIELD_CLIENT:
      return getBKFCard97DataCheck
    case NRG_CLIENT:
    case GENON_CLIENT:
    case LANYARD_CLIENT:
      return getNRGCard97DataCheck
    default:
      return getCard97DataCheck
  }
}

export const getRetrieveServiceByClient = client => {
  switch (client) {
    case DUCK_CLIENT:
      return getDukeCard97ByPost
    case DOM_CLIENT:
      return getDominionCard97ByPost
    case BROOKFIELD_CLIENT: {
      return getBkfCard97ByPost
      //  return getBkfCard97
    }
    // case PJM_CLIENT:
    //   return getCard97PJM
    case NRG_CLIENT:
    case GENON_CLIENT:
    case LANYARD_CLIENT:
      return getNRGCard97ByPost
    default:
      return getCard97ByPost
  }
}

export const getSaveServiceByClient = client => {
  switch (client) {
    case DUCK_CLIENT:
      return postDukeCard97
    case DOM_CLIENT:
      return postDominionCard97
    case BROOKFIELD_CLIENT:
      return postBrookfieldCard97
    case NRG_CLIENT:
    case GENON_CLIENT:
    case LANYARD_CLIENT:
      return postNRGCard97
    default:
      return postCard97
  }
}

export const getDeleteServiceByClient = client => {
  switch (client) {
    case DUCK_CLIENT:
      return deleteDukeCard97
    case DOM_CLIENT:
      return deleteDominionCard97
    case BROOKFIELD_CLIENT:
      return postBrookfieldCard97Delete
    case NRG_CLIENT:
    case GENON_CLIENT:
    case LANYARD_CLIENT:
      return postNRGCard97Delete
    default:
      return deleteCard97
  }
}

export const getEventBreakerData = targetInfo => data =>
  post(
    targetInfo,
    `cards/card97-breaker-verify?${querystring.stringify(data)}`
  )()

// this is used for pi-breaker-verification
// current client is for COOP,BEPC,TOTENG

export const multipleSaveByPiBreakerVerifyService = (
  targetInfo,
  client
) => data => {
  return post(targetInfo, 'cards/card97-verification-save-multiple')(data) // TO DO : need to update api by client
}
